/** @format */

export const CLEANER = "cleaner";
export const MANAGER = "manager";
export const SUPER_ADMIN = "super_admin";
export const HQ = "hq";
export const HRM = "health_reports_manager";
export const RE = "recruiter";
export const MO = "medical_officer";
export const DOCTOR = "doctor";
export const GENERAL_PRACTITIONER = "general_practitioner";
export const CM = "complaints_manager";
export const GenericUsers = [2];

// First matching role is used as the login portal role.
// doctor is before general_practitioner so a user with both enters the doctor portal.
export const PORTAL_ROLE_PRIORITY = [
  SUPER_ADMIN,
  HQ,
  RE,
  MANAGER,
  CLEANER,
  HRM,
  CM,
  MO,
  DOCTOR,
  GENERAL_PRACTITIONER,
];

export function pickPortalRole(roles) {
  const names = (Array.isArray(roles) ? roles : [])
    .map((role) => (typeof role === "string" ? role : role?.name))
    .filter(Boolean);
  return PORTAL_ROLE_PRIORITY.find((role) => names.includes(role)) || names[0] || null;
}

export function isDoctorPortalRole(role) {
  return role === DOCTOR || role === MO || role === GENERAL_PRACTITIONER;
}
